import { CSSObject } from '@chakra-ui/react';
import { ExoticsActionSchema, TButton } from './Action.styles';

export const exoticsActionStyles: ExoticsActionSchema = {
  buttonExoticsActionProps: {
    variant: 'solid',
    fontSize: 'sm',
    fontWeight: 'bold',
    minW: 'auto',
    w: '30px',
    h: '30px',
    lineHeight: 'normal',
    border: '2px',
    borderColor: 'white',
    sx: {
      '&&': {
        h: '8',
        w: 'auto',
      },
    },
  },
};

export const Button = ({ isSelected }: TButton): CSSObject => ({
  bg: isSelected ? 'beta.200' : 'beta.500',
  color: isSelected ? 'beta.800' : 'white',
  '&&': {
    boxShadow: isSelected ? 'inset 0px 2px 4px #A97F81' : 'lg',
  },
  '&:hover': {
    bg: isSelected ? 'beta.300' : 'beta.800',
  },
  border: '2px',
  borderColor: 'white',
  boxSize: ['25px', '30px'],
  borderRadius: 'base',
  fontSize: ['xs', 'sm'],
  fontWeight: 'semibold',
  minWidth: 'unset',
  '&:disabled': {
    boxShadow: 'none',
    cursor: 'default',
    '&&': {
      color: 'gray.500',
      bg: 'blackAlpha.200',
    },
  },
  '&:disabled:hover': {
    bg: 'none',
  },
});

export const CheckboxRunnerBoxed: CSSObject = {
  '.chakra-checkbox__control': {
    bg: 'white',
    color: 'gray.700',
    borderColor: 'gray.300',
    _hover: {
      bg: 'white',
    },
  },
  _checked: {
    bg: 'beta.100',

    '.chakra-checkbox__control': {
      border: '1px',
      borderColor: 'beta.200',
    },
  },

  '.chakra-checkbox__label': {
    marginInlineStart: '0',
  },
  flexDir: 'column',
  gap: '2',
  boxSize: '30px',
  borderRadius: 'base',
  bg: 'blackAlpha.200',
  alignItems: 'center',
  justifyContent: 'center',
};

export const FlexOdds: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'semibold',
  bg: ['unset', 'blackAlpha.200'],
  alignItems: 'center',
  w: ['8', '12'],
  justifyContent: 'center',
  px: '1',
  py: ['1', null, '0.5'],
  minW: '10',
  textAlign: 'center',
  borderRadius: 'base',
  whiteSpace: 'nowrap',
  mr: '0',
  color: 'gray.600',
  h: '30px',
};

export const ActionsContainer: CSSObject = {
  display: 'flex',
  flexDir: 'row',
  gap: ['1', null, '2'],
};
